import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ChatsTable from '../ChatsTable/ChatsTable';
import TicketsTable from '../TicketsTable/TicketsTable';
import KnowledgeBaseTable from '../KnowledgeBaseTable/KnowledgeBaseTable';

const SearchResults = ({ chats, tickets, articles, activeTab, searchQuery, hideChats }) => {
    const visibleChats = hideChats ? [] : chats;
    const hasResults = visibleChats.length > 0 || tickets.length > 0 || articles.length > 0;

    if (!hasResults) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <Typography sx={{ color: '#93A1B0', fontFamily: 'Inter', fontSize: '16px', fontWeight: 400 }}>
                    No results found
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            {(activeTab === 'all' || activeTab === 'chats') && visibleChats.length > 0 && (
                <ChatsTable chats={visibleChats} searchQuery={searchQuery} />
            )}

            {(activeTab === 'all' || activeTab === 'tickets') && tickets.length > 0 && (
                <TicketsTable tickets={tickets} searchQuery={searchQuery} />
            )}

            {(activeTab === 'all' || activeTab === 'knowledgeBase') && articles.length > 0 && (
                <KnowledgeBaseTable articles={articles} searchQuery={searchQuery} />
            )}

            {activeTab === 'recent' && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <Typography sx={{ color: '#93A1B0', fontFamily: 'Inter', fontSize: '16px', fontWeight: 400 }}>
                        No recent searches
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default SearchResults;
